import { Injectable } from '@angular/core';
import { LegacyUsersClient, MigrateLegacyUserRequest } from '../generated/api-client';

export {
  LegacyUserForMigrationDataDto,
  FilterDataDto,
  LegacyUserDto,
  MigrateLegacyUserRequest,
} from '../generated/api-client';
export type { IMigrateLegacyUserRequest } from '../generated/api-client';

/**
 * Thin wrapper over the NSwag-generated LegacyUsersClient.
 */
@Injectable({ providedIn: 'root' })
export class LegacyUsersApiService {
  constructor(private readonly client: LegacyUsersClient) {}

  getAllLegacyUsers(
    validOnly?: boolean,
    searchText?: string | null,
    libraryLevel?: string | null,
    area?: string | null,
    distrito?: string | null,
    comunidad?: string | null,
    page?: number,
    pageSize?: number,
  ) {
    return this.client.getAllLegacyUsers(
      validOnly,
      searchText,
      libraryLevel,
      area,
      distrito,
      comunidad,
      page,
      pageSize,
    );
  }

  getFilterData() {
    return this.client.getFilterData();
  }

  getLegacyUserByEmail(email: string) {
    return this.client.getLegacyUserByEmail(email);
  }

  migrateUser(request: MigrateLegacyUserRequest) {
    return this.client.migrateUser(request);
  }
}
